import { render, staticRenderFns } from "./pageFive.vue?vue&type=template&id=2983577c&scoped=true"
import script from "./pageFive.vue?vue&type=script&lang=js"
export * from "./pageFive.vue?vue&type=script&lang=js"
import style0 from "./pageFive.vue?vue&type=style&index=0&id=2983577c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2983577c",
  null
  
)

export default component.exports